import {
  ArrowBackIosRounded,
  ArrowForwardIosRounded,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import React from "react";
import styles from "./carousel.module.css"
import { WEB_COLORS } from "@/lib/constants";

const Arrows = ({ prevSlide, nextSlide, isPrevActive, isNextActive }) => {
  return (
    <Grid container className="arrows" gap={1}>
      <Box sx={{ borderRadius: "50%", p:1,   }}  color={!isPrevActive? WEB_COLORS.darkTeal:"#fff"}className={isPrevActive ? styles["active"] : styles["inactive"]}>
        <ArrowBackIosRounded onClick={prevSlide} />
      </Box>
      <Box sx={{ borderRadius: "50%", backgroundColor: WEB_COLORS.darkTeal, p:1 }}  color={!isNextActive?WEB_COLORS.darkTeal:"#fff"} className={isNextActive ? styles["active"] : styles["inactive"]}>
        <ArrowForwardIosRounded onClick={nextSlide} />
      </Box>
    </Grid>
  );
};

export default Arrows;
